// Module
var code = "<div class=\"non-blocking-loading\" ng-style=\"{height: loadingHeight}\"> <img src=\"../../../../content/css/default/flex_loading.gif\" alt=\"\"/> {{loadingText}} </div> ";
// Exports
module.exports = code;